import api from '../api'
import fetchDelayed from '@/store/helper/fetchDelayed'

const fetch = (context, args, delay=500) => {
  return fetchDelayed.fetch(
    api,
    context,
    "Cargando examenes",
    args,
    delay
  );
}

const answer = ({ commit }, args) => {
  commit('SENDING_ANSWER', true);

  return api.submit(args)
  .then((response) => {
    commit('SENDING_ANSWER', false);
    commit('ADD_USER_ANSWER', args);

    return response;
  })
  .catch((error) => {
    commit('SENDING_ANSWER', false);
    return error.response;
  });
}

const review = ({ commit }, args) => {
  commit('SENDING_REVIEW', args);
  return api.review(args)
  .then(response => {
    commit('SENDING_REVIEW', false);
    return response;
  })
  .catch( error => {
    commit('SENDING_REVIEW', false);
    return error;
  });
}

export default {
  fetch,
  answer,
  review,
}
